
var Base = require('./_BaseView'),
    scope = require('scope'),
    ViewParents = require('../partials/Parents'),
    queryString = require('query-string'),
    View =  Base.extend({
        template: require('templates/pages/home.hbs'),
        name: 'home',
        ui: {
            'form': '#planoSaudeForm',
            'btnAdd': '#btnAdd',
            'parents': '.planosaude__dependentes-ref',
            'citySelect': '[data-city-select]',
            'professionSelect': '[data-profession-select]',
            'entitiesSelect': '[data-entities-select]'
        },
        events: {
            'click @ui.btnAdd': 'addDependant',
            'change @ui.citySelect': 'selectCityLoadProfession',
            'change @ui.professionSelect': 'selectProfessionLoadEntities',
            'change @ui.entitiesSelect': 'selectEntitiesUpdateKinship'
        },
        regions: {
        },
        behaviors: {
            Form: require('../behaviors/Form')
        },
        onAttach: function(){
            var self = this;
            scope.metrics.pageview('home');
            var query = queryString.parse(location.search);
            if (query['profissao']) {
                self.$el.find('.planosaude__input-profissao')/*.hide()*/.find('select').prop('readonly', true);
            }
            if (query['entidade']) {
                self.$el.find('.planosaude__input-entidades')/*.hide()*/.find('select').prop('readonly', true);
            }
            this.ui.form.on('submitSuccess', function (e, resultados, formData) {
                
                scope.app.anchor(0);
                var View = require('views/Result');
                scope.app.go(new View({
                    data:  resultados
                }));
            });
            
            $('.checkbox__semplano').on('change', function(){
                if (this.checked) {
                    $('.planosaude__input-valor').hide();
                    $('#valor_atual').val('');
                } else 
                    $('.planosaude__input-valor').show();                
             })
        },
        numberDependants: 0,
        addDependant: function(e) {
            e.preventDefault();

            var self = this;
            var divParent = new ViewParents({
                data: {
                    counter: ++self.numberDependants
                }
            });

            divParent.load().done(function(){
                divParent.render();

                var divParentEl = divParent.$el.find('.planosaude__dependentes');

                divParentEl.on('click', '.planosaude__field-remove',function(e){
                    e.preventDefault();
                    divParentEl.remove();

                    self.numberDependants--;
                });

                divParentEl.appendTo(self.ui.parents);

                self.updateKinshipElements(divParentEl);
            })

        },
        selectCityLoadProfession: function(e) {
            var self = this,
            $selectElm = $(e.target),
            professionParent = self.ui.professionSelect.parent();

            // if ($(e.currentTarget).attr('readonly')) {
            //     return;
            // }
            self.$el.find('[data-reset-on*="cidade"]').each(function () {
                $(this).attr('readonly','true').html('<option value="">Escolha</option>').val("").trigger('change');
            });
            professionParent.addClass('loading');
            $.ajax({
                url: self.ui.professionSelect.data('profession-select').replace('%cityId%', $selectElm.val()),
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    self.ui.professionSelect.html('<option value="">Escolha</option>');
                    $('[data-city-clear]').val('');
                    var $elms = $.each(data, function(idx, elm) {
                        if(idx == '' && elm == '') return;
                        
                        var opt = new Option(elm.label, elm.value, false, false);
                        $(opt).appendTo(self.ui.professionSelect);
                    });
                    self.ui.professionSelect.removeAttr('readonly');
                    if (data.length == 1) {
                        self.ui.professionSelect.val(data[0].value).trigger('change').attr('readonly', true);
                    } else {
                        self.ui.professionSelect.attr('readonly', false);
                    }
                    // self.ui.professionSelect.trigger('change');
                },
                complete: function() {
                    professionParent.removeClass('loading');
                }
            });
        },
        selectProfessionLoadEntities: function(e) {
            var self = this,
            $selectElm = $(e.target),
            entitiesParent = self.ui.entitiesSelect.parent();
            if ($(e.currentTarget).attr('readonly')) {
                return;
            }
            self.$el.find('[data-reset-on*="profissao"]').each(function () {
                $(this).attr('readonly','true').html('<option value="">Escolha</option>').val("").trigger('change');
            });
            entitiesParent.addClass('loading');
            $.ajax({
                url: self.ui.entitiesSelect.data('entities-select')
                    .replace('%cityId%', self.ui.citySelect.val())
                    .replace('%professionId%', $selectElm.val()),
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    self.ui.entitiesSelect.html('<option value="">Escolha</option>');
                    $('[data-entity-clear]').val('');
                    var $elms = $.each(data, function(idx, elm) {
                        if(idx == '' && elm == '') return;
                        
                        var opt = new Option(elm.label, elm.value, false, false);
                        $(opt).appendTo(self.ui.entitiesSelect);
                    });

                    self.entities = data;
                    self.ui.entitiesSelect.removeAttr('readonly');
                    if (data.length == 1) {
                        self.ui.entitiesSelect.val(data[0].value).trigger('change').attr('readonly', true);
                    } else {
                        self.ui.entitiesSelect.attr('readonly', false);
                    }
                    // self.ui.entitiesSelect.trigger('change');

                },
                complete: function() {
                    entitiesParent.removeClass('loading');
                }
            });
        },
        selectEntitiesUpdateKinship: function(e){
            var self = this,
                $selectElm = $(e.target);

            var val = $selectElm.val()

            if(self.entities){
                for(var x = 0; x < self.entities.length; x++){
                    var entitie = self.entities[x];

                    if(entitie.value === val){
                        self.kinship = entitie.kinship;
                        self.updateKinshipElements(self.$el);
                        self.health_care = entitie.health_care;
                        self.updateHealthCare();
                        return;
                    }
                }
            }
            self.ui.form.toggleClass('no-has-health-care', true);
        },
        updateHealthCare() {
            var self =this;
            self.ui.form.toggleClass('no-has-health-care', !self.health_care);
            self.$el.find('[data-dont-healthcare]').attr('disabled', !self.health_care );
        },
        updateKinshipElements: function(parent){
            var self = this;

            parent.find('.planosaude__input-parentesco-select').each(function(){
                var select = $(this);
                select.html('<option value="">Selecione</option>');
                
                var $elms = $.each(self.kinship, function(idx, elm) {
                    if(idx == '' && elm == '') return;
                    
                    var opt = new Option(elm.label, elm.value, false, false);
                    $(opt).appendTo(select);
                });

                select.removeAttr('disabled');
            });

            self.updateHealthCare();
        },
    });
module.exports = View;



// WEBPACK FOOTER //
// ./resources/scripts/views/Home.js